import { Prices } from 'utils/types';
import { StyledActualPrice } from './style';

interface IActualPriceProps {
  prices: Prices;
  textShadow?: string;
}

export const ActualPrice: React.FC<IActualPriceProps> = ({
  prices,
  textShadow = '0px 1px 1px rgba(0, 0, 0, 0.3)',
}) => {
  const { priceInUsdCents, priceDisplay, strokedPriceDisplay } = prices;
  return (
    <StyledActualPrice textShadow={textShadow}>
      {priceInUsdCents && <span className="final-price">{priceDisplay}</span>}
      {strokedPriceDisplay && (
        <span className="stroked">{strokedPriceDisplay}</span>
      )}
    </StyledActualPrice>
  );
};
